const en = {
    nothingAddedMessage: 'Nothing added to favorites',
    myFavoriteTitle: 'My favorites',
    goToHomePageBtn: 'To the home page',
}

const rus = {
    nothingAddedMessage: 'Ничего не добавлено в избранное',
    myFavoriteTitle: 'Избранные товары',
    goToHomePageBtn: 'Вернуться на главную страницу',
}

const hebrew = {
    nothingAddedMessage: 'לא נוספו מודעות למועדפים',
    myFavoriteTitle: 'המועדפים שלי',
    goToHomePageBtn: 'לדף הבית',
}

const choose = { en, rus, hebrew };

export default choose;